// misc/* page translations
const misc = {
  myPage: {
    title: 'Trang của tôi',
    subtitle: 'Quản lý thông tin tài khoản của tôi',
    editInfo: 'Chỉnh sửa thông tin',
    cancel: 'Hủy',
    save: 'Lưu',
    joinDate: 'Ngày tham gia',
    lastLogin: 'Đăng nhập gần nhất',
    basicInfo: 'Thông tin cơ bản',
    name: 'Tên',
    email: 'Email',
    phone: 'Số điện thoại',
    department: 'Phòng ban',
    role: 'Vai trò',
    changePassword: 'Đổi mật khẩu',
    currentPassword: 'Mật khẩu hiện tại',
    currentPasswordPlaceholder: 'Nhập mật khẩu hiện tại',
    newPassword: 'Mật khẩu mới',
    newPasswordPlaceholder: 'Nhập mật khẩu mới (từ 8 ký tự)',
    confirmPassword: 'Xác nhận mật khẩu mới',
    confirmPasswordPlaceholder: 'Nhập lại mật khẩu mới',
    submitPassword: 'Đổi mật khẩu',
    passwordMismatch: 'Mật khẩu mới không khớp.',
    passwordChanged: 'Đã đổi mật khẩu.',
    defaultName: 'Kim Admin',
    defaultRole: 'Quản trị hệ thống',
    defaultDepartment: 'Nhóm IT',
  },
  notFound: {
    title: 'Không tìm thấy trang',
    message: 'Trang bạn yêu cầu không tồn tại hoặc đã được di chuyển.',
    goBack: 'Trang trước',
    goHome: 'Về trang chủ',
  },
  modelDashboard: {
    title: 'Bảng điều khiển hiệu suất mô hình',
    subtitle: 'Trạng thái và phân tích hiệu suất các mô hình phát hiện bất thường đã huấn luyện',
    summaryBtn: 'Tóm tắt',
    refresh: 'Làm mới',
    gpuLive: 'GPU Live',
    mockData: 'Dữ liệu giả lập',
    errorPrefix: 'Kết nối máy chủ GPU thất bại: {error}',
    loading: 'Đang tải dữ liệu...',
    historyLoading: 'Đang tải lịch sử huấn luyện...',
    noHistory: 'Không có lịch sử huấn luyện',
    kpi: {
      lstm: 'Mô hình LSTM',
      ae: 'Mô hình AE',
      total: 'Tổng số mô hình',
      totalData: 'Tổng dữ liệu sử dụng',
      unitCount: '',
      unitRecords: '',
    },
    table: {
      modelId: 'ID mô hình',
      equipment: 'Thiết bị',
      mold: 'Khuôn',
      valLoss: 'Val Loss',
      accuracy: 'Độ chính xác',
      precision: 'Precision',
      recall: 'Recall',
      f1: 'F1',
      fpr: 'FPR',
      dataCount: 'Số dữ liệu',
      trainedAt: 'Ngày huấn luyện',
      empty: 'Không có mô hình đã huấn luyện',
    },
    detail: {
      confusionMatrix: 'Ma trận nhầm lẫn (Confusion Matrix)',
      predNormal: 'Dự đoán: Bình thường',
      predAnomaly: 'Dự đoán: Bất thường',
      actualNormal: 'Thực tế: Bình thường',
      actualAnomaly: 'Thực tế: Bất thường',
      tn: 'TN',
      fp: 'FP (Báo nhầm)',
      fn: 'FN (Bỏ sót)',
      tp: 'TP',
      validSample: 'Mẫu xác thực',
      validSampleSuffix: '{n}',
      accuracyLabel: 'Độ chính xác',
      fprLabel: 'Tỷ lệ báo nhầm (FPR)',
      trainThreshold: 'Train Threshold',
      valThreshold: 'Val Threshold',
      cmNote: '* Ground Truth: Val 95th percentile | Prediction: Train 95th percentile',
      trainingCurve: 'Đường cong huấn luyện',
      totalEpoch: 'Tổng {n} Epoch',
      convergence: 'Hội tụ: {n} Epoch',
      finalValLoss: 'Val Loss cuối: {n}',
      reduction: 'Giảm: {n}%',
    },
    summary: {
      title: 'Tóm tắt hiệu suất mô hình phát hiện bất thường',
      subtitle: 'Smart Injection Monitoring - AI Model Performance Report',
      totalModels: 'Tổng số mô hình',
      totalData: 'Tổng dữ liệu huấn luyện',
      lstmCount: 'Mô hình LSTM',
      aeCount: 'Mô hình AE',
      modelCount: '{n} mô hình',
      avgAccuracy: 'Độ chính xác TB',
      avgPrecision: 'Precision TB',
      avgRecall: 'Recall TB',
      avgF1: 'F1 Score TB',
      trainData: 'Dữ liệu huấn luyện',
      retrainNeeded: 'Cần huấn luyện lại',
      footerNote: 'Confusion Matrix: Ground Truth = Val 95th Percentile, Prediction = Train 95th Percentile Threshold',
      unitCount: '',
      unitRecords: '',
    },
  },
};

export default misc;
